import { useEffect, useState } from 'react';
import { contabilidadService } from '../../services/api';
import '../../styles/Clientes.css';

const CuadreRutas = () => {
  const [loading, setLoading] = useState(false);
  const [fechaInicio, setFechaInicio] = useState('');
  const [fechaFinal, setFechaFinal] = useState('');
  const [ruta, setRuta] = useState('');
  const [rutas, setRutas] = useState([]);
  const [cuadre, setCuadre] = useState(null);

  useEffect(() => {
    cargarRutas();
    // Establecer fechas por defecto
    const hoy = new Date();
    const primerDia = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
    setFechaInicio(primerDia.toISOString().split('T')[0]);
    setFechaFinal(hoy.toISOString().split('T')[0]);
  }, []);

  const cargarRutas = async () => {
    try {
      const response = await contabilidadService.getRutas();
      setRutas(response.data);
    } catch (error) {
      console.error('Error al cargar rutas:', error);
    }
  };

  const formatMoney = (amount) => {
    return `$${(amount || 0).toLocaleString('es-DO', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  };

  const handleGenerarCuadre = async () => {
    if (!fechaInicio || !fechaFinal) {
      alert('Por favor seleccione las fechas');
      return;
    }

    setLoading(true);
    try {
      const params = {
        fecha_inicio: fechaInicio,
        fecha_fin: fechaFinal
      };

      if (ruta) {
        params.ruta_id = ruta;
      }

      const response = await contabilidadService.getCuadreRutas(params);
      setCuadre(response.data);
    } catch (error) {
      console.error('Error al generar cuadre:', error);
      alert('Error al generar el cuadre de rutas: ' + (error.response?.data?.error || error.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>🗺️ Cuadre por Rutas</h1>
        <p>Cuadre de pagos organizados por rutas de cobro</p>
      </div>

      <div className="card">
        <div className="card-header">
          <h2>Parámetros del Cuadre</h2>
        </div>
        <div className="card-body">
          <div className="form-grid" style={{ gridTemplateColumns: 'repeat(4, 1fr)' }}>
            <div className="form-group">
              <label>Fecha Inicial</label>
              <input
                type="date"
                value={fechaInicio}
                onChange={(e) => setFechaInicio(e.target.value)}
                className="form-control"
              />
            </div>

            <div className="form-group">
              <label>Fecha Final</label>
              <input
                type="date"
                value={fechaFinal}
                onChange={(e) => setFechaFinal(e.target.value)}
                className="form-control"
              />
            </div>

            <div className="form-group">
              <label>Ruta</label>
              <select
                value={ruta}
                onChange={(e) => setRuta(e.target.value)}
                className="form-control"
              >
                <option value="">--- Seleccione ---</option>
                {rutas.map(r => (
                  <option key={r.id} value={r.id}>
                    {r.nombre}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group" style={{ display: 'flex', alignItems: 'flex-end' }}>
              <button
                onClick={handleGenerarCuadre}
                disabled={loading || !fechaInicio || !fechaFinal}
                className="btn btn-primary"
                style={{ width: '100%' }}
              >
                {loading ? 'Generando...' : 'Actualizar'}
              </button>
            </div>
          </div>
        </div>
      </div>

      {cuadre && (
        <>
          {/* Resumen de Totales */}
          <div className="card">
            <div className="card-header">
              <h2>Resumen General</h2>
            </div>
            <div className="card-body">
              <div className="stats-grid" style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(5, 1fr)',
                gap: '1rem'
              }}>
                <div style={{
                  padding: '1rem',
                  background: '#f8f9fa',
                  borderRadius: '8px',
                  textAlign: 'center'
                }}>
                  <div style={{ fontSize: '0.875rem', color: '#666', marginBottom: '0.5rem' }}>
                    Pagos
                  </div>
                  <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#2196F3' }}>
                    {cuadre.totales.pagos}
                  </div>
                </div>

                <div style={{
                  padding: '1rem',
                  background: '#f8f9fa',
                  borderRadius: '8px',
                  textAlign: 'center'
                }}>
                  <div style={{ fontSize: '0.875rem', color: '#666', marginBottom: '0.5rem' }}>
                    Capital
                  </div>
                  <div style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#4CAF50' }}>
                    {formatMoney(cuadre.totales.capital)}
                  </div>
                </div>

                <div style={{
                  padding: '1rem',
                  background: '#f8f9fa',
                  borderRadius: '8px',
                  textAlign: 'center'
                }}>
                  <div style={{ fontSize: '0.875rem', color: '#666', marginBottom: '0.5rem' }}>
                    Intereses
                  </div>
                  <div style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#FF9800' }}>
                    {formatMoney(cuadre.totales.intereses)}
                  </div>
                </div>

                <div style={{
                  padding: '1rem',
                  background: '#f8f9fa',
                  borderRadius: '8px',
                  textAlign: 'center'
                }}>
                  <div style={{ fontSize: '0.875rem', color: '#666', marginBottom: '0.5rem' }}>
                    Mora
                  </div>
                  <div style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#F44336' }}>
                    {formatMoney(cuadre.totales.mora)}
                  </div>
                </div>

                <div style={{
                  padding: '1rem',
                  background: '#2196F3',
                  borderRadius: '8px',
                  textAlign: 'center',
                  color: 'white'
                }}>
                  <div style={{ fontSize: '0.875rem', marginBottom: '0.5rem' }}>
                    Total
                  </div>
                  <div style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
                    {formatMoney(cuadre.totales.total)}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Tabla por Rutas */}
          <div className="card">
            <div className="card-header">
              <h2>Detalle por Rutas</h2>
              <button className="btn btn-success">
                📥 Generar Reporte
              </button>
            </div>
            <div className="table-container">
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Ruta</th>
                    <th>Pagos</th>
                    <th>Capital</th>
                    <th>Intereses</th>
                    <th>Mora</th>
                    <th>Total</th>
                    <th>%</th>
                  </tr>
                </thead>
                <tbody>
                  {cuadre.detalle_rutas.map((ruta, index) => (
                    <tr key={index}>
                      <td><strong>{ruta.ruta}</strong></td>
                      <td>{ruta.pagos}</td>
                      <td>{formatMoney(ruta.capital)}</td>
                      <td>{formatMoney(ruta.intereses)}</td>
                      <td>{formatMoney(ruta.mora)}</td>
                      <td><strong>{formatMoney(ruta.total)}</strong></td>
                      <td>
                        <span style={{
                          padding: '0.25rem 0.5rem',
                          background: '#4CAF50',
                          color: 'white',
                          borderRadius: '4px',
                          fontSize: '0.875rem'
                        }}>
                          {((ruta.total / cuadre.totales.total) * 100).toFixed(1)}%
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr style={{ background: '#f8f9fa', fontWeight: 'bold' }}>
                    <td>TOTALES:</td>
                    <td>{cuadre.totales.pagos}</td>
                    <td>{formatMoney(cuadre.totales.capital)}</td>
                    <td>{formatMoney(cuadre.totales.intereses)}</td>
                    <td>{formatMoney(cuadre.totales.mora)}</td>
                    <td>{formatMoney(cuadre.totales.total)}</td>
                    <td>100%</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </>
      )}

      {!cuadre && (
        <div style={{
          padding: '3rem',
          textAlign: 'center',
          color: '#666',
          background: '#f8f9fa',
          borderRadius: '8px',
          margin: '2rem 0'
        }}>
          <p style={{ fontSize: '1.125rem', margin: 0 }}>
            📊 Seleccione las fechas y opcionalmente una ruta, luego haga clic en "Actualizar"
          </p>
        </div>
      )}
    </div>
  );
};

export default CuadreRutas;
